import React from "react";

function PrivacyPolicy() {
  return (
    <>
      <div className="container my-5">
        <div className="col-12 d-flex justify-content-center">
          <h3 className="underline">Privacy Policy</h3>
        </div>
        <p className="text-center mt-2">
          This Privacy Policy explains how{" "}
          <a href="https://nrcbe-bananastore.com/" target="blank">www.nrcbe-bananastore.com</a>{" "}
          (“we”, “our”, “us”) collects, uses, and protects any personal
          information that you provide while using this website. We are
          committed to safeguarding your privacy and ensuring that your personal
          data is handled responsibly and securely. We may update this policy
          periodically by revising this page, and you are encouraged to review
          it regularly to remain informed about any changes.
        </p>
        <section className="mt-4">
          <h6>Information we collect</h6>
          <p>We may collect the following details to serve you better:</p>
          <ul className="mt-2">
            <li>
              Name and contact details (email address, mobile number, postal
              address).
            </li>
            <li>
              Demographic information such as postcode, preferences, and
              interests.
            </li>
            <li>
              Information related to feedback, surveys, or promotional offers.
            </li>
          </ul>
        </section>

        <section className="mt-4">
          <h6>Purpose of data collection</h6>
          <p>
            Your information is collected and processed for the following
            purposes:
          </p>
          <ul className="mt-2">
            <li>To maintain internal records and improve our services.</li>
            <li>
              To inform you about new products, offers, or updates relevant to
              your interests.
            </li>
            <li>
              To customize our website experience according to your preferences.
            </li>
            <li>To contact you for feedback or market research purposes. </li>
          </ul>
        </section>
        <section className="mt-4">
          <h6>Shipping Policy</h6>
          <p>
            nrcb-bananastore will take 7-10 days normally for delivery of products to
            customer destination.
          </p>
        </section>
        <section className="mt-4">
          <p>
            Orders placed through{" "}
            <a href="https://nrcbe-bananastore.com/" target="blank">
              www.nrcbe-bananastore.com
            </a>{" "}
            will typically be delivered within 7–10 working days to the
            customer’s destination, depending on location and courier
            availability.
          </p>
        </section>
        <section className="mt-4">
          <h6>Data security</h6>
          <p>
            We have implemented appropriate physical, electronic, and managerial
            measures to protect your personal information against unauthorized
            access, alteration, or disclosure.
          </p>
        </section>
        <section className="mt-4">
          <h6>Cookies</h6>
          <p>
            Our website uses cookies to enhance user experience by analyzing web
            traffic and tailoring content to your preferences. You can choose to
            accept or decline cookies through your browser settings. Declining
            cookies may limit certain functionalities of the website.
          </p>
        </section>
        <section className="mt-4">
          <h6>External links</h6>
          <p>
            Our website may contain links to external websites. Please note that
            we are not responsible for the privacy practices or content of those
            sites. We advise you to review the privacy statements of any
            external website you visit.
          </p>
        </section>
        <section className="mt-4">
          <h6>Managing your personal information</h6>
          <p>
            You may opt out of direct marketing communications or request
            corrections to your personal information by contacting us through
            the details provided on the website. We will not share, sell, or
            lease your personal information to third parties without your
            consent, except where required by law.
          </p>
        </section>
      </div>
      <div className="container my-5">
        <div className="col-12 d-flex justify-content-center">
          <h3 className="underline">Terms and Conditions</h3>
        </div>
        <section className="mt-4">
          <p>
            This document constitutes an electronic record under the Information
            Technology Act, 2000 and its applicable rules. By accessing or using{" "}
            <a href="https://nrcbe-bananastore.com/" target="blank">
              www.nrcbe-bananastore.com
            </a>{" "}
            , you agree to comply with the terms and conditions outlined herein.
          </p>
          <p>
            The domain name{" "}
            <a href="https://nrcbe-bananastore.com/" target="blank">
              www.nrcbe-bananastore.com
            </a>{" "}
            (hereinafter referred to as “Website”) is owned and operated by
            ICAR–National Research Centre for Banana (NRCB), Tiruchirapalli. By
            using this Website, you agree to the Terms of Use, Privacy Policy,
            and all applicable policies governing transactions made herein.
          </p>
        </section>
        <section className="mt-4">
          <h6>Eligibility</h6>
          <p>
            Use of the Website is permitted only to individuals who can legally
            form binding contracts under the Indian Contract Act, 1872. Users
            below the age of 18 years are not eligible to use this Website.
          </p>
        </section>
        <section className="mt-4">
          <h6>Account Responsibility</h6>
          <p>
            Users are responsible for maintaining the confidentiality of their
            login credentials. Any unauthorized use of your account must be
            reported immediately.{" "}
            <a href="https://nrcbe-bananastore.com/" target="blank">
              www.nrcbe-bananastore.com
            </a>{" "}
            is not liable for any loss arising from misuse of your account.
          </p>
        </section>
        <section className="mt-4">
          <h6>Pricing and Orders</h6>
          <p>
            While every effort is made to ensure accurate pricing and product
            information, typographical errors may occur. We reserve the right to
            correct such errors, cancel orders, or update pricing without prior
            notice. Orders are confirmed only upon dispatch of the product.
          </p>
        </section>
        <section className="mt-4">
          <h6>Payment and Transactions</h6>
          <p>
            All transactions must be made in Indian Rupees (INR). Payments can
            be made through UPI, debit/credit card, or other available options.
            In case of failed transactions or cancellations, refunds will be
            processed within 7–10 working days to the source account.
          </p>
        </section>
        <section className="mt-4">
          <h6>Cancellations and Refunds</h6>
          <ul className="mt-2">
            <li>
              Customer Cancellations: Orders cancelled before dispatch will be
              refunded in full.
            </li>
            <li>
              Post-Dispatch Cancellations: Once dispatched, cancellations are
              subject to our return policy.
            </li>
            <li>
              Institutional Cancellations: The website reserves the right to
              cancel any order due to stock unavailability, pricing
              discrepancies, or suspected fraudulent activity.
            </li>
          </ul>
        </section>
        <section className="mt-4">
          <h6>Promotions and Offers</h6>
          <p>
            Promotional codes, discounts, or bundled offers are subject to
            specific terms and conditions and cannot be combined unless
            explicitly stated. Free items received under promotional offers must
            be returned if the associated purchase is cancelled.
          </p>
        </section>
        <section className="mt-4">
          <h6>Fraudulent Transactions</h6>
          <p>
            Any fraudulent activity, including unauthorized use of payment
            instruments, will result in immediate termination of the account and
            may invite legal action under applicable laws.
          </p>
        </section>
        <section className="mt-4">
          <h6>Modification of Terms</h6>
          <p>
            We reserve the right to revise or update these Terms and Conditions
            and/or the Privacy Policy at any time without prior notice.
            Continued use of the Website constitutes acceptance of the modified
            terms.
          </p>
        </section>
      </div>
    </>
  );
}

export default PrivacyPolicy;
